export const LOGGER_ENTER_ROUTES = {
  'experience-lesson-experience-courses': 'experience-lesson',
  'CaptchaLogin-phone': 'login',
  'wechatLoginSelect': 'login',
}